import React from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import tlBG from "../../assets/images/gradientBg.png";
import { ReactComponent as Pin } from "../../assets/svg/map-pin.svg";
import {
	WeddingAlbumImage,
	WeddingAlbumWrapper,
	WeddingDate,
} from "./component";
import dayjs from "dayjs";

const WeddingAlbumCard = ({
	details,
	handleClick = () => {
		return null;
	},
}) => {
	const name = `${details.bride_firstname} & ${details.groom_firstname}`;
	return (
		<WeddingAlbumWrapper
			onClick={() => {
				handleClick();
			}}>
			<WeddingAlbumImage
				preview={false}
				src={details?.story_cover_image_url || tlBG}
				alt={details?.name}
				placeholder={
					<WeddingAlbumImage
						preview={false}
						src={details?.story_cover_image_url || tlBG}
					/>
				}
			/>
			<WeddingDate tw="h-16! w-12! absolute top-2 right-2">
				<span tw="text-appPinkSaturated text-base font-bold uppercase m-0!">
					{dayjs(details?.date).format("MMM")}
				</span>
				<span tw="text-black! text-base font-bold uppercase m-0!">
					{dayjs(details?.date).format("DD")}
				</span>
			</WeddingDate>

			<div tw="p-1.5">
				<h4 tw="mb-1">{name}</h4>
				<div tw="inline-flex items-center gap-2 ">
					<Pin />
					<span tw="text-sm  font-medium truncate capitalize opacity-70">
						{details?.venue}
					</span>
				</div>
			</div>
		</WeddingAlbumWrapper>
	);
};

export default WeddingAlbumCard;
